import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { Component } from 'react';
import { Button } from 'antd';
import Modal from 'components/ui-ant/Feedback/modal';
import { parameterizedString } from 'theme/utils';
import '../../main/style.css';

class OutOfStockModal extends Component {
  redirect = (url) => {
    const { history } = this.props;
    history.push(url);
  };

  render() {
    const { visible, stockLocationName, packageNumber } = this.props;

    return (
      <Modal
        className='package-modal'
        visible={visible}
        onCancel={this.redirect.bind(this, $R.PACKAGE_ORDER_LIST.path)}
        title={$ST.WARNING}
        centered
        footer={[
          <Button
            key='submit'
            type='primary'
            onClick={this.redirect.bind(this, $R.PACKAGE_ORDER_LIST.path)}
          >
            {$ST.OKAY}
          </Button>,
        ]}
      >
        {parameterizedString(
          $ST.LOCATION_WITH_PACKAGE_NUMBER,
          stockLocationName,
          packageNumber
        )}
      </Modal>
    );
  }
}

export default OutOfStockModal;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/modals/outOfStock/index.js